'use strict';

define('lib/analytics/blocks/index',[
  './section.block',
  './keymetrics',
  './offer.block',
  './offer.list.block',
  './dealer.search.block',
  './dealer.block',
  './error.block',
  './error.slp.block',
  './link.block',
  './series.block',
  './compare.block',
  './global.block',
  './list.block',
  './list.item.block',
  './user.block',
  './inventory.list.block'
], function (
  sectionBlock,
  keyMetrics,
  offerBlock,
  offerListBlock,
  dealerSearchBlock,
  dealerBlock,
  errorBlock,
  errorSlpBlock,
  linkBlock,
  seriesBlock,
  compareBlock,
  globalBlock,
  listBlock,
  listItemBlock,
  userBlock,
  inventoryListBlock
) {
  return {
    sectionBlock: sectionBlock,
    keyMetrics: keyMetrics,
    offerBlock: offerBlock,
    offerListBlock: offerListBlock,
    dealerSearchBlock: dealerSearchBlock,
    dealerBlock: dealerBlock,
    errorBlock: errorBlock,
    errorSlpBlock: errorSlpBlock,
    linkBlock: linkBlock,
    seriesBlock: seriesBlock,
    compareBlock: compareBlock,
    globalBlock: globalBlock,
    listBlock: listBlock,
    listItemBlock: listItemBlock,
    userBlock: userBlock,
    inventoryListBlock: inventoryListBlock
  };
});

